import { Skeleton, Divider, Radio, Space, Row, Col, Button, Modal, Select, message, ConfigProvider, Input, Form, Checkbox } from 'antd';
import React, { useEffect, useState, useRef, useContext } from 'react';
import axios from 'axios';
import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom'
import { EditOutlined, RollbackOutlined, PlusOutlined, ArrowRightOutlined } from '@ant-design/icons';
import InfiniteScroll from 'react-infinite-scroll-component';
import Label_language from '../language';
import BlogCard from './components/BlogCard';
import TitleModal from './components/TitleModal';
import Carousel_news_ticker from './components/Carousel_news_ticker';
import WYSIWYGModal from './components/WYSIWYGModal';
import PicModal from './components/PicModal';
import NewCourseModal from './components/NewCourseModal';

const label_language = Label_language.cramschool.children
const NewCourse = () => {
    const [dimensions, setDimensions] = useState({
        height: window.innerHeight,
        width: window.innerWidth
    });
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [class_id, set_class_id] = useState('');
    const language = useContext(ConfigProvider.ConfigContext).locale.locale
    const [fileList, setFileList] = useState([]);
    const [title, setTitle] = useState(label_language.Common.children.edit[language]);
    const [edit, setEdit] = useState(false);
    const [open, setOpen] = useState(false);
    const [picOpen, setPicOpen] = useState(false);
    const [open_wyswyg, set_open_wyswyg] = useState(false);
    const [open_wyswyg1, set_open_wyswyg1] = useState(false);
    const [title_modal, set_tiltle_modal] = useState(false);
    const [course_modal, set_course_modal] = useState(false);
    const [form_data, set_form_data] = useState([]);
    const [learn_english_year, set_learn_english_year] = useState([]);
    const [student, setStudent] = useState();
    const [color, setColor] = useState('d65b77');
    const [editcard, setEditCard] = useState({});
    const [titleEditcard, setTitleEditCard] = useState({ background_color: null, color_show: null, file_show: null, file_id: [], file_url: [] });
    const [content, setContent] = useState('');
    const [data, setData] = useState([]);
    const [page, setpage] = useState(1);
    const [total, setTotal] = useState(1);
    const [itemdatacheck, setitemdatacheck] = useState(true);
    const [messageApi, contextHolder] = message.useMessage();
    const [permission, setPermission] = useState(false);
    const [grade_option, set_grade_option] = useState([]);
    const [additional_test, set_additional_test] = useState('');
    const [datas, setDatas] = useState([{
        key: 1,
        name: 'client',
        placeholder: '名字（必填）',
        type: 'input',
        value: '',
        required: 'true',
    }, {
        key: 2,
        name: 'phone',
        placeholder: '電話（必填）',
        type: 'input',
        value: '',
        required: 'true',
    }, {
        key: 3,
        name: 'school',
        placeholder: '就讀學校（必填）',
        type: 'input',
        value: '',
        required: 'true',
    }, {
        key: 4,
        name: 'grade_id',
        placeholder: '現今同學的年級',
        type: 'select',
        value: '',
    }, {
        key: 7,
        name: 'school_score',
        placeholder: '在校成績（必填）',
        type: 'input',
        value: '',
        required: 'true',
    }, {
        key: 8,
        name: 'learn_english_year_id',
        placeholder: '學習英文多久',
        type: 'select',
        value: '',
    }, {
        key: 5,
        name: 'e_mail',
        placeholder: '電子郵件（選填）',
        type: 'input',
        value: '',
        required: 'false',
    }, {
        key: 6,
        name: 'question',
        placeholder: '想瞭解的事情（選填）',
        type: 'input',
        value: '',
        required: 'false',
    }])
    const handleOnEdit = (key) => {
        setTitle(label_language.Common.children.edit[language]);
        setColor('f09a45');
        setEdit(true);
        data.map((value, index) => {
            if (index == key) {
                setEditCard((pre) => {
                    return ({
                        ...value,
                        font_color: value.font_color == null ? '#000000' : value.font_color,
                        background_color: value.background_color == null ? '#ffef9882' : value.background_color,
                        enroll_status_background_color: value.enroll_status_background_color == null ? '#FF0000' : value.enroll_status_background_color,
                        enroll_status_font_color: value.enroll_status_font_color == null ? '#FFFFFF' : value.enroll_status_font_color,
                        pic_background_color: value.pic_background_color == null ? '#FFFFFF' : value.pic_background_color,
                    })
                });
            }
        })
        setOpen(true)
    }
    useEffect(() => {
        const debouncedHandleResize = function handleResize() {
            setDimensions({
                height: window.innerHeight,
                width: window.innerWidth
            });
        };

        window.addEventListener("resize", debouncedHandleResize);

        return _ => {
            window.removeEventListener("resize", debouncedHandleResize);
        };
    }, [])
    const get_data = () => {
        axios
            .get('/cramSchool/api/blog/new_class')
            .then((response) => {
                if (page == 1) {
                    setData(response.data.data);
                    setTotal(response.data.total)
                    get_picture(response.data.data);
                } else {
                    setData(pre => { return ([...pre, ...response.data.data]) });
                    setTotal(response.data.total)
                    get_picture([...data, ...response.data.data]);
                }
            })
            .finally(() => {
                setitemdatacheck(false)
            })
    }
    const get_picture = (data_tmp) => {
        // console.log(data_tmp);
        data_tmp && data_tmp.map((value, index) => {
            let blog_id = value['blog_id']
            if (value.file_id.length != 0) {
                value.file_id.map((tmp, key) => {
                    // console.log(key, tmp);
                    // tmp['file_id']
                    axios
                        .get('/cramSchool/api/file', { responseType: 'blob', params: { "file_id": tmp } })
                        .then((response) => {
                            var blob_ = new Blob([response.data], {
                                type: "image/jpg",// this is the only MIME for SVG

                            });
                            const dataurl = URL.createObjectURL(blob_);
                            setData(
                                (pre) => {
                                    return (
                                        pre.map((value, index) => {
                                            if (blog_id == value.blog_id) {
                                                if (value.file_url != undefined) {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [...value.file_url, dataurl]
                                                        }
                                                    )
                                                } else {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [dataurl]
                                                        }
                                                    )
                                                }
                                            } else {
                                                return (
                                                    { ...value }
                                                )

                                            }
                                        })
                                    )
                                }
                            )

                        })
                })
            }
        })
    }
    const get_header = () => {
        axios
            .get('/cramSchool/api/blog/header/new_class', { params: { "blog_type_id": 21 } })
            .then((response) => {
                setContent(response.data.data[0]);
                getSloganFile(response.data.data[0].file_id);
            })
    }
    const getSloganFile = (data_tmp) => {
        const data_arr_tmp = [];
        if (data_tmp.length != 0) {
            data_tmp && data_tmp.map((value, index) => {
                axios
                    .get('/cramSchool/api/file', { responseType: 'blob', params: { "file_id": value } })
                    .then((response) => {
                        var blob_ = new Blob([response.data], {
                            type: "image/jpg",// this is the only MIME for SVG

                        });
                        const dataurl = URL.createObjectURL(blob_);
                        data_arr_tmp.push({ uid: value, url: dataurl })
                        setFileList(data_arr_tmp);
                    })
            })
        }
    }
    const get_title = () => {
        axios
            .get('/cramSchool/api/blog/type', { params: { 'blog_type_id': 21 } })
            .then((response) => {
                let color_tmp = response.data.data[0].background_color.split(',');
                // console.log(color_tmp);
                setTitleEditCard(
                    (pre) => {
                        return (
                            {
                                ...pre,
                                background_color1: color_tmp[0],
                                background_color2: color_tmp[1],
                                color_show: response.data.data[0].color_show,
                            }
                        )
                    }
                )
                if (response.data.data[0].file_id.length != 0) {
                    let data_tmp = [];
                    response.data.data[0].file_id.map((tmp, i) => {
                        axios
                            .get('/cramSchool/api/file', { responseType: 'blob', params: { "file_id": tmp } })
                            .then((response) => {
                                var blob_ = new Blob([response.data], {
                                    type: "image/jpg",// this is the only MIME for SVG

                                });
                                const dataurl = URL.createObjectURL(blob_);
                                data_tmp.push({ uid: tmp, url: dataurl })
                                setTitleEditCard((pre) => {
                                    if (tmp.file_url != undefined) {
                                        return (
                                            {
                                                ...pre,
                                                file_id: [...tmp.file_id, tmp],
                                                file_url: [...tmp.file_url, dataurl]
                                            }
                                        )
                                    } else {
                                        return (
                                            {
                                                ...pre,
                                                file_id: [tmp],
                                                file_url: [dataurl]
                                            }
                                        )
                                    }
                                })
                            })
                    })
                    setTitleEditCard((pre) => {
                        return (
                            {
                                ...pre,
                                file_show: response.data.data[0].file_show,
                                // file_id: data_tmp.map((item) => item.uid),
                                // file_url: data_tmp.map((item) => item.url)
                            }
                        )
                    })
                }
            })
    }
    useEffect(() => {
        get_data();
        get_header();
        get_title();
        axios
            .get('/cramSchool/api/permission')
            .then((response) => {
                if (response.data.length != 0) {
                    setPermission(true);
                }
            })
        get_grade();
        get_learn_english();
    }, [])
    const handleEdit = (file_id) => {
        setOpen(false);
        // let data_tmp = [{ ...editcard }];
        if (editcard['file_id'] == "{0}") {
            editcard['file_id'] = null;
        }
        // console.log(editcard); 
        axios
            .patch(`/cramSchool/api/blog/new_class`, [{ ...editcard, file_id }])
            .then((response) => {
                if (response.data.status == 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: label_language.Common.children.edit_error[language],
                    });
                    get_data();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: label_language.Common.children.edit_success[language],
                    });
                    get_data();
                }
            })
    }
    const handleUpdate = (file_id) => {
        var Today = new Date();
        let time = `${Today.getFullYear()}-${Today.getMonth() + 1}-${Today.getDate()}`;
        axios
            .patch(`/cramSchool/api/blog/header/new_class`, [
                {
                    // "title": 'lesson_category_header',
                    // "content": content,
                    ...content,
                    "blog_type_id": 21,
                    "annoucement_time": time,
                    // "blog_id": 107,
                    file_id
                }])
            .then((response) => {
                if (response.data.status == 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: label_language.Common.children.edit_error[language],
                    });
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: label_language.Common.children.edit_success[language],
                    });
                }
                get_header();
                set_open_wyswyg(false);
                setPicOpen(false);
            })
    }
    useEffect(() => {
        data.forEach(each_item => {
            if (each_item.blog_id === editcard.blog_id) {
                setEditCard(prev => (
                    {
                        ...prev,
                        file_url: each_item.file_url
                    }
                ))
            }
        })
    }, [data])
    const handleTitleUpdate = (file_id) => {
        // console.log({ ...titleEditcard, background_color: `${titleEditcard.background_color1},${titleEditcard.background_color2}`, file_id: file_id });
        axios
            .patch('/cramSchool/api/blog/type', [{
                ...titleEditcard,
                background_color: `${titleEditcard.background_color1},${titleEditcard.background_color2}`,
                file_id: file_id,
                blog_type_id: 21
            }])
            .then((response) => {
                if (response.data.status == 'failure') {
                    set_tiltle_modal(false);
                    messageApi.open({
                        type: 'error',
                        content: label_language.Common.children.edit_error[language],
                    });
                } else {
                    set_tiltle_modal(false);
                    messageApi.open({
                        type: 'success',
                        content: label_language.Common.children.edit_success[language],
                    });
                }
                get_title();
            })
    }
    const handleChange = (name, value) => {
        set_form_data(pre => {
            return ({
                ...pre,
                [`${name}`]: value
            })
        })
    }

    useEffect(() => {
        // console.log(page)
        get_data();
    }, [page])
    const ChangePage = () => {
        if (itemdatacheck) {
            return;
        }
        // setLoading(true);
        setitemdatacheck(false);
        setpage(pre => pre + 1)
    }
    const handleOnShow = (class_id) => {
        set_course_modal(true);
        set_class_id(class_id);
    }
    const get_grade = () => {
        axios
            .get('/cramSchool/api/grade')
            .then((response) => {
                let data_tmp = [];
                response.data.data.map((value, index) => {
                    let data_json_tmp = {};
                    data_json_tmp['value'] = value['id']
                    data_json_tmp['label'] = `${value['name']}`;
                    data_tmp.push(data_json_tmp);
                })
                set_grade_option(data_tmp)
            })
    }
    const get_learn_english = () => {
        axios
            .get('/cramSchool/api/learn_english_year')
            .then((response) => {
                let data_tmp = [];
                response.data && response.data.map((value, index) => {
                    let data_json_tmp = {};
                    data_json_tmp['value'] = value['learn_english_year_id']
                    data_json_tmp['label'] = `${value['name']}`;
                    data_tmp.push(data_json_tmp);
                })
                set_learn_english_year(data_tmp);
            })
    }
    const handleSubmit = () => {
        console.log([{ ...form_data, class_id: class_id }]);
        if (form_data['client'] != '' && form_data['phone'] != '' && form_data['grade_id'] && form_data['school']) {
            axios
                .post('/cramSchool/api/contact', [{ ...form_data, class_id: class_id }])
                .then((response) => {
                    if (response.data.status == 'failure') {
                        messageApi.open({
                            type: 'error',
                            content: '送出失敗',
                        });
                    } else {
                        messageApi.open({
                            type: 'success',
                            content: '已成功送出，會盡快聯繫',
                        });
                    }
                })
            set_course_modal(false);
        } else {
            messageApi.open({
                type: 'error',
                content: '請確認資料是否填寫完整',
            });
        }
        set_class_id(null);
        set_form_data({});
        form.resetFields()
    }
    return (<>
        {contextHolder}
        <Modal title="填單預約" open={course_modal} onOk={e => handleSubmit()} onCancel={e => { set_course_modal(false); set_form_data({}); form.resetFields() }} width={600}>
            <Row gutter={[8, 8]}>
                {/* <Col span={24}>
                    <Radio.Group onChange={e => setStudent(e.target.value)}>
                        <Row gutter={16}>
                            <Col>
                                <Radio value={1} style={{ color: '#006D9B', fontSize: '15px' }}>我是舊生</Radio>
                            </Col>
                            <Col>
                                <Input placeholder="請輸入學號"></Input>
                            </Col>
                            <Col>
                                <Radio value={0} style={{ color: '#006D9B', fontSize: '15px' }}>我是新生</Radio>
                            </Col>
                        </Row>
                    </Radio.Group>
                </Col> */}
                {/* {student === 0 ? <> */}
                <Col span={24}  >
                    <Form autoComplete="off" form={form}>
                        <Row gutter={[8, 8]}>
                            {grade_option && datas.map((value, key) => {
                                if (value.type == 'select') {
                                    if (value.key == 4) {
                                        return (
                                            <Col span={12}  >
                                                <Select
                                                    style={{
                                                        width: "100%",
                                                    }}
                                                    labelInValue
                                                    placeholder={value.placeholder}
                                                    value={form_data['grade_name'] && form_data['grade_name']}
                                                    onChange={(value) => set_form_data(pre => {
                                                        return ({
                                                            ...pre,
                                                            'grade_id': value.value,
                                                            'grade_name': value.label,
                                                        })
                                                    })}
                                                    options={grade_option}
                                                />
                                            </Col>
                                        )
                                    } else {
                                        return (
                                            <Col span={12} >
                                                <Select
                                                    style={{
                                                        width: "100%",
                                                    }}
                                                    labelInValue
                                                    placeholder={value.placeholder}
                                                    value={form_data['learn_english_year_id'] && form_data['learn_english_year_id']}
                                                    onChange={(value) => set_form_data(pre => {
                                                        return ({
                                                            ...pre,
                                                            'learn_english_year_id': value.value,
                                                            'learn_english_year_name': value.label,
                                                        })
                                                    })}
                                                    options={learn_english_year}
                                                />
                                            </Col>
                                            // <Col span={12}>
                                            //     <Input
                                            //         placeholder={value.placeholder}
                                            //         onClick={e => set_form_data(pre => {
                                            //             return ({
                                            //                 ...pre,

                                            //             })
                                            //         })}
                                            //     ></Input>
                                            // </Col>
                                        )
                                    }

                                } else {
                                    return (
                                        <Col span={12}  >
                                            <Form.Item
                                                // {...formItemLayout}
                                                name={value.name}
                                                label=""
                                            // rules={[
                                            //     {
                                            //         required: `${value.required}`,
                                            //         message: '',
                                            //     },
                                            // ]}
                                            >
                                                <Input placeholder={value.placeholder}
                                                    onChange={(e) => handleChange(value.name, e.target.value)}
                                                    value={form_data[`${value.name}`] && form_data[`${value.name}`]}
                                                />
                                            </Form.Item>

                                        </Col>
                                    )
                                }
                            })}
                            <Col span={24}>
                                <Row gutter={[0, 16]}>
                                    <Col span={24} style={{ color: '#006D9B', fontSize: '17px' }}>有無考取檢定*</Col>
                                    <Col sm={{ span: 24 }} md={{ span: 20 }}>
                                        <Col span={24}>
                                            <Radio.Group onChange={(e) => set_additional_test(e.target.value)} value={additional_test}>
                                                <Space direction="vertical">
                                                    <Row>
                                                        {/* <Col sm={{ span: 24 }} md={{ span: 12 }}> */}
                                                        <Radio value={1} style={{ color: '#006D9B', fontSize: '15px' }}>有</Radio>
                                                        {/* </Col> */}
                                                        {additional_test == '1' && (
                                                            <Col sm={{ span: 24 }} md={{ span: 18 }} >
                                                                <Input
                                                                    value={form_data['test_name'] || ''}
                                                                    placeholder={'請輸入檢定名稱'}
                                                                    onChange={(e) => additional_test == '1' ?
                                                                        set_form_data(pre => {
                                                                            return ({
                                                                                ...pre,
                                                                                'test_name': e.target.value
                                                                            })
                                                                        }) : null} />
                                                            </Col>)}
                                                    </Row>
                                                    {/* <Col sm={{ span: 12 }} md={{ span: 12 }}> */}
                                                    <Radio value={0} style={{ color: '#006D9B', fontSize: '15px' }}>沒有</Radio>
                                                    {/* </Col> */}
                                                </Space>
                                            </Radio.Group>

                                        </Col>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Form>
                </Col>
                {/* </> : null} */}
            </Row>
        </Modal>
        <WYSIWYGModal
            open={open_wyswyg}
            setOpen={set_open_wyswyg}
            data={content?.content}
            setData={setContent}
            handleUpdate={handleUpdate}
        />
        <TitleModal
            open={title_modal}
            setOpen={set_tiltle_modal}
            title={'修改'}
            color={'f09a45'}
            edit={true}
            name={'開課資訊'}
            editcard={titleEditcard}
            setEditCard={setTitleEditCard}
            handleEdit={handleTitleUpdate}
            fileShow={true}
        />
        <PicModal
            picOpen={picOpen}
            setPicOpen={setPicOpen}
            handleSubmit={handleUpdate}
            fileList={fileList}
        ></PicModal>
        <NewCourseModal
            open={open}
            edit={edit}
            title={title}
            color={color}
            editcard={editcard}
            setEditCard={setEditCard}
            setOpen={setOpen}
            handleEdit={handleEdit}
        />
        <Row gutter={[8, 24]} justify={'end'}>
            {permission ? <>
                <Col >
                    <Button className='example' style={{ backgroundColor: '#f09a45', color: '#FFFFFF' }} onClick={e => set_tiltle_modal(true)}>編輯標題</Button>
                </Col>
            </> : null}
            {titleEditcard?.color_show == 1 ? <Col span={24}>
                <Row justify={'center'} align="middle" style={{ backgroundImage: `linear-gradient(to right, ${titleEditcard.background_color1}, #ffffff,${titleEditcard.background_color2})`, padding: '10px', position: 'relative' }}>
                    <Col style={{ textAlign: 'center' }}>
                        <span style={{ fontSize: '3rem' }}>開課資訊</span>
                    </Col>
                    {/* <Col style={{ position: 'absolute', left: '90%', top: '0%' }}>
                            <Button className='example' size='large' shape="circle" icon={<EditOutlined />} style={{ position: 'absolute', top: 0, right: 0, backgroundColor: '#F9D4E5' }} onClick={e => set_open_wyswyg(true)} />
                        </Col> */}
                </Row>
            </Col> : null}
            {titleEditcard?.file_show == 1 ? <Col span={24}>
                <Carousel_news_ticker
                    logo
                    height={'100%'}
                    file_url={titleEditcard?.file_url != undefined && titleEditcard?.file_url.length != 0 && titleEditcard?.file_url.map(map_item => map_item)}
                />
            </Col> : null}
            <Col span={24}>
                <Row gutter={[40, 16]} justify="center" align="middle" style={{ padding: '10px' }}>
                    <Col md={{ span: 6 }} sm={{ span: 24 }}>
                        <Row gutter={[8, 8]}>
                            <Col span={24} style={{ borderTop: 'solid #f5be9d 1px ' }}> </Col>
                            <Col span={24} style={{ borderTop: 'solid #f5be9d 5px ' }}> </Col>
                        </Row>
                    </Col>
                    <Col md={{ span: 8 }} sm={{ span: 24 }} >
                        <Row justify={'center'}>
                            <Col >
                                <span dangerouslySetInnerHTML={{ __html: content.content }}></span>
                            </Col>
                        </Row>

                    </Col>
                    <Col md={{ span: 6 }} sm={{ span: 24 }} style={{ position: 'relative' }}>
                        <Row gutter={[8, 8]} >
                            <Col span={24} style={{ borderTop: 'solid #f5be9d 1px ' }}> </Col>
                            <Col span={24} style={{ borderTop: 'solid #f5be9d 5px ' }}> </Col>
                        </Row>
                        {permission ? <>
                            <Col className='example' style={{ position: 'absolute', top: '-350%', left: 0 }}>
                                <EditOutlined
                                    className='example'
                                    style={{
                                        backgroundColor: '#F9D4E5',
                                        fontSize: '1.2rem',
                                        borderRadius: '50%',
                                        padding: '8px'
                                    }}
                                    onClick={e => set_open_wyswyg(true)}
                                />
                            </Col>
                        </> : null}
                    </Col>
                </Row>
            </Col>
            <Col span={24}>
                <InfiniteScroll
                    dataLength={data?.length}
                    next={ChangePage}
                    hasMore={data?.length < total}
                    loader={
                        <Skeleton
                            paragraph={{
                                rows: 1,
                            }}
                            active
                        />
                    }
                    endMessage={<Divider plain>已經沒有貼文囉</Divider>}
                    scrollableTarget="scrollableDiv"
                >
                    <Row gutter={[16, 16]} style={{ padding: '10px' }}>
                        <BlogCard title={true}
                            edit={permission}
                            span={8}
                            data={data}
                            type={'straight'}
                            page={'NewCourse'}
                            handleOnEdit={handleOnEdit}
                            handleOnShow={handleOnShow}
                        />
                    </Row>
                </InfiniteScroll>
            </Col>
        </Row>
    </>)
}
export default NewCourse;